import atob from 'atob';

export interface JwtDeserialized {
  type: string;
  'user-id': string;
  roles: string[];
  'app-id': string;
  exp: number;
  iat: number;
  'external-services-package-id': string;
}

export function deserializeJwt(jwt: string): JwtDeserialized | null {
  const payloadUrl = jwt?.split('.')[1];

  if (!payloadUrl) {
    return null;
  }

  const payload = payloadUrl.replace('-', '+').replace('_', '/');
  return payload ? JSON.parse(atob(payload)) : null;
}
